<script>
    // import {PeriodAnchorInstructionModel} from '@/common/models/plan-model';
    import _ from '@/common/helpers/index';
    import {DateTimeFormats} from '../../common/datetime-formats';

    // todo: how to get the $tz in the functional component?
    /**
     * Time format
     * Server response time (client timezone) -> string time HH:mm
     */
    const formatTime = (time, tz) => tz.readTime(time)
        .format(DateTimeFormats.shortTime);

    export default {
        name: 'recurring-interval-preview',
        functional: true,
        props: {
            model: {
                type: Object, // PeriodAnchorInstructionModel
                required: true,
            },
        },
        render(h, {props: {model}, ...context}) {
            const {
                day, time, week,
            } = model;

            // returns render day of week
            if (week) {
                return h('span', [
                    'Set on the ',
                    h('span', [
                        _.unKebabCase(week, false),
                        _.nbsp(h),
                        day.toLowerCase(),
                    ]),
                    time
                        ? h('span', [
                            ' ',
                            'at',
                            _.nbsp(h),
                            formatTime(time, context.parent.$tz()),
                        ])
                        : '',
                ]);
            }

            // returns render day of month
            return h('span', [
                'Set on the ',
                context.parent.$filters.ordinal(day),
                time
                    ? h('span', [
                        ' ',
                        'at',
                        _.nbsp(h),
                        formatTime(time, context.parent.$tz()),
                    ])
                    : '',
            ]);
        },
    };
</script>
